import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponsePackage } from '../models/util.model';
import { AppConfig } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  private pathApi = this.config.setting['pathApi'] + "image/";
  private headers = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http: HttpClient, private config: AppConfig) { }
  getAddress(obj: { latitude: number, longitude: number }) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}getAddress`, obj, {headers: this.headers, observe: 'response'});
  }
}
